<!--系统消息-->
<template>
  <div class="system_message_container">
    <div class="title">
      <div class="left_box">
        <span class="close_text iconfont iconchevron-left" @click="routerBack" />
<!--        <span class="index_length">{{ slideIndex + 1 }}/{{ imgObjList.length }}</span>-->
      </div>
      <h1>社区通知</h1>
    </div>
    <div class="body">
      <cube-scroll :data="[messageList]" :options="options" @pulling-up="onPullingUp">
<!--        <div class="message_item_container" v-for="(item,index) in messageList" :key="index">-->
          <template v-for="(item,index) in messageList">
            <message-item :community-data="item" data-type="detail" :key="index"></message-item>
          </template>
<!--        </div>-->
        <w-more-loading v-show="moreLoadingShow"/>
<!--        <w-no-more v-show="noMoreShow"/>-->
        <w-no-results text="暂无系统消息" v-show="messageList.length===0"/>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
import api from '@/api/api-list'
import MessageItem from './components/message-item'
import WNoMore from '../../components/global/w-no-more'
import WMoreLoading from '../../components/global/w-more-loading'
import WNoResults from './components/discuss-no-result'
import { componentsMixin } from '@/assets/js/mixin/components'
import { mapMutations } from 'vuex'
export default {
  name: "systemMessage",
  mixins: [ componentsMixin ],
  components:{
    MessageItem,
    WNoMore,
    WMoreLoading,
    WNoResults
  },
  data() {
    return {
      messageList:[],
      messagePage:1,
      messageTotal:0,
      options: {
        pullUpLoad: true
      }, // scroll 事件配置
    }
  },
  computed :{
    // 加载更多的loading
    moreLoadingShow () {
      return this.messageList.length < this.messageTotal
    },
    // 没有更多的显示状态
    noMoreShow () {
      return this.messageList.length!=0 && this.messageList.length === this.messageTotal
    }
  },
  mounted() {
    this.getMessageList();
  },
  methods: {
  	...mapMutations('community', [ 'setUnViewCount' ]),
    // 获取消息列表
    async getMessageList(){
      let res = await api.blog.getSystemMessage({page:this.messagePage,size:10});
      if (res.code===1000){
        this.messageList = res.data.news;
        this.messageTotal = res.data.total_count;
        this.setUnViewCount(0)
      }else {
        this.showToast(res.message, 1500);
      }
    },
    // 返回上一级
    routerBack(){
      this.$router.back();
    },
    // 上拉加载
    async onPullingUp () {
      if (this.messagePage * 10 < this.messageTotal){
        this.messagePage += 1
        let res = await api.blog.getSystemMessage( { page: this.messagePage ,size:10});
        if (res.code===1000){
          this.messageList = [...this.messageList,...res.data.news];
          this.messageTotal = res.data.total_count;
        }else {
          this.showToast(res.message,1500);
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.system_message_container{
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  .title {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #404040;
    border-bottom: 1px solid #F4F4F4;
    background-color: #fff;
    font-size: 16px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .left_box {
      position: absolute;
      left: 10px;
      display: flex;
      align-items: center;
      .close_text {
        font-weight: bold;
      }
      .iconfont {
        font-size: 26px;
        font-weight: bold;
        margin-right: 16px;
        &.iconmenu {
          font-weight: 400;
          font-size: 22px;
        }
      }
    }

  }
  .body{
    width: 100%;
    height: 100vh;
    //margin-top: 44px;
    padding-top: 44px;
    .message_item_container{
      margin-bottom: 10px;
    }
  }
}
</style>
